import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Questionnaire from './app';
import './styles.scss';
export default class QuestionnaireModule {
  constructor(config,$modules) {
    $modules.each((index,el)=> {
      let $el = $(el);
      if($el.hasClass('module-loaded')) {
        return;
      }
      let configId = $el.data('config-id');
      let moduleData = config.find( (data) => {
        return data['config-id']==configId;
      })
      if(!moduleData) return;
      let props =  {
        qid: moduleData.id,
        formId: moduleData.form,
        title: moduleData.title,
        questionNumberText: moduleData.questionNumberText,
        flagRequired: moduleData.flagRequired,
        configId: moduleData['config-id']
      };
      ReactDOM.render(React.createElement(Questionnaire,props),el);
      $el.addClass('module-loaded');
    })
  }
}
QuestionnaireModule.selector = '[data-module="Questionnaire"]'
QuestionnaireModule.init = (config,$modules) => {
  $modules = $modules || $(QuestionnaireModule.selector);
  if($modules.length>0){
    new QuestionnaireModule(config,$modules);
  }
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/index.js